import PropertyListItem from './PropertyListItem';

export default PropertyListItem;
